export default __webpack_public_path__ + "static/media/grid1.13da20b0.svg";